module.exports = __webpack_public_path__ + "img/name.40a0cb8c.png";